import { doc, getDoc, updateDoc } from 'firebase/firestore';
import moment from 'moment';
import { db } from './firebase';

// * Function to fetch the transaction summary
export const fetchTransactionsAndSummary = async (userId) => {
    try {
        const userDoc = await getDoc(doc(db, 'swiss-h', userId));
        if (userDoc.exists()) {
            const userData = userDoc.data();
            let fetchedTransactions = userData.transactions || [];

            // First, sort transactions by date (latest date first)
            fetchedTransactions = fetchedTransactions.sort((a, b) => {
                // Compare by date first (without time)
                const dayA = moment(a.date).startOf('day');
                const dayB = moment(b.date).startOf('day');
                if (dayA.isBefore(dayB)) {
                    return 1;  
                } else if (dayA.isAfter(dayB)) {
                    return -1; 
                }

                // If dates are the same, sort by time (latest time first)
                return moment(b.date).isBefore(moment(a.date)) ? 1 : -1;
            });

            // Calculate balance and summary
            const calculatedBalance = fetchedTransactions.reduce((total, transaction) => {
                return transaction.type === 'credit' ? total + transaction.amount : total - transaction.amount;
            }, 0);

            const summary = fetchedTransactions.reduce(
                (acc, transaction) => {
                    acc.totalTransactions += 1;
                    const amount = transaction.type === 'debit' ? -transaction.amount : transaction.amount;
                    if (transaction.type === 'credit') {
                        acc.allCredits += transaction.amount;
                    } else {
                        acc.allDebits += transaction.amount;
                    }
                    if (transaction.account === 'Savings') {
                        acc.savings += amount;
                    } else if (transaction.account === 'Investments') {
                        acc.investments += amount;
                    } else if (transaction.account === 'Loans') {
                        acc.loans += amount;
                    }
                    return acc;
                },
                { savings: 0, investments: 0, loans: 0, allDebits: 0, allCredits: 0, totalTransactions: 0 }
            );

            return { fetchedTransactions, calculatedBalance, summary };
        } else {
            throw new Error('User not found.');
        }
    } catch (error) {
        throw new Error('Error fetching transactions: ' + error.message);
    }
};

// * Function to save and update a transaction
export const saveUpdatedTransaction = async (userId, transactions, selectedTransaction) => {
    const updatedTransactions = [...transactions];
    const index = transactions.findIndex(t => t.date === selectedTransaction.date && t.amount === selectedTransaction.amount);
    updatedTransactions[index] = selectedTransaction;

    try {
        await updateDoc(doc(db, 'swiss-h', userId), {
            transactions: updatedTransactions,
        });
        return updatedTransactions;
    } catch (error) {
        throw new Error('Error updating transaction: ' + error.message);
    }
};

// * Function to delete a transaction record
export const deleteTransaction = async (userId, transactions, selectedTransaction) => {
    const updatedTransactions = transactions.filter((t) => t !== selectedTransaction);

    try {
        await updateDoc(doc(db, 'swiss-h', userId), {
            transactions: updatedTransactions,
        });
        return updatedTransactions;
    } catch (error) {
        throw new Error('Error deleting transaction: ' + error.message);
    }
};
